import { useState } from "react";
import ReportFilters from "../components/reports/ReportFilters";
import LeadReport from "../components/reports/LeadReport";
import RevenueReport from "../components/reports/RevenueReport";
import TeamReport from "../components/reports/TeamReport";
import { Users, IndianRupee, Users2 } from "lucide-react";

const tabs = [
  { key: "leads", label: "Lead Analytics", icon: Users },
  { key: "revenue", label: "Revenue", icon: IndianRupee },
  { key: "team", label: "Team Performance", icon: Users2 },
];

const Reports = () => {
  const [reportType, setReportType] = useState("leads");
  const [filters, setFilters] = useState({ startDate: "", endDate: "" });

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Reports & Analytics</h1>
        <p className="text-sm text-gray-500 mt-1">Detailed insights into your business performance</p>
      </div>
      <div className="flex space-x-1 bg-gray-100 rounded-xl p-1 w-fit">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setReportType(tab.key)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              reportType === tab.key
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            <tab.icon className="w-4 h-4" />
            {tab.label}
          </button>
        ))}
      </div>
      <ReportFilters onFilter={setFilters} />
      {reportType === "leads" && <LeadReport filters={filters} />}
      {reportType === "revenue" && <RevenueReport filters={filters} />}
      {reportType === "team" && <TeamReport filters={filters} />}
    </div>
  );
};

export default Reports;
